import { useSelector } from 'react-redux';
import { keepPreviousData } from '@tanstack/react-query';

import { Environment, AppID } from '@playq/octopus-common';
import { GenericFailure } from '@playq/services-shared';
import { AliasId, AliasData, IdentificationResponse } from '@playq/services-fingerprint';

import { IUseQueryOptionsExtended, useEitherQuery } from '/api/service-hooks';
import { services2 } from '/api/services2';
import { appToolkit } from '/store';

import { playerLookupKeys } from './constants';

export const useLoginWithAliasAsUser = (
  { alias, update, env }: { alias: AliasId; update: AliasData | undefined; env: Environment },
  options?: IUseQueryOptionsExtended<IdentificationResponse | undefined, GenericFailure | Error>
) => {
  const appID: AppID | undefined = useSelector(appToolkit.selectors.appID);
  return useEitherQuery(
    playerLookupKeys.loginByAliasAsUser(alias, env, update, appID),
    () => {
      if (appID) {
        return services2.fingerprintLookupService.loginWithAliasAsUser(appID, alias, update, env);
      }
    },
    {
      placeholderData: keepPreviousData,
      ...options,
    }
  );
};
